import { TypeSearch, TypeSearchTargetPage } from "./common.type";

interface CommonRequest {
  baseUrlEncoded: string;
  date: string;
}

export interface IVerifyRegistrationRequest {
  crawlId: string;
  crawlerGroupId: string;
  crawlHistoryId: string;
  crawlUrl: string;
  crawlDate: string;
  isCheckLink: boolean;
  isCheckContent: boolean;
  numberOfPages: number;
  basicAuth: {
    username: string;
    password: string;
  } | null;
  isSystem?: boolean;
  selectedDomains?: string[];
  domain?: string;
  sub?: string;
}

export interface CommonKeyObj {
  contractId: string;
  serviceGroupId: string;
  baseUrlEncoded: string;
  date: string;
}

export type PageInfo = {
  urlId: string;
  title: string;
  pageUrl: string;
  shortUrl: string;
};

export interface ILinkSummary {
  statusCodes: number[];
  pageInfo: Record<string, PageInfo>;
  pageMapping: Record<string, string>;
}

export interface IErrorLink {
  link: string;
  statusCode: number;
  indexDetectedPages: number[];
  isOpen: boolean;
  detectedPages: PageInfo[];
  titles: string[];
}

export interface IDetectedLink {
  url: string;
  title: string;
  detectedLink: string;
  isSameDomain: boolean;
  statusCode: number;
}

export interface IGetDetectedLinkRequest extends CommonRequest {
  pageTitle?: string;
  pageUrl?: string;
  linkDestinationType?: boolean | null;
  detectedLink?: string;
  statusCodes?: number[];
  offset: number;
}

export interface RawContentsSearchResult extends PageInfo {
  line: number;
  data: string;
  rawHtmlLine?: string;
}

export interface ContentsSearchResult extends RawContentsSearchResult {
  shortUrl: string;
  content: string;
  title: string;
  pageUrl: string;
}

export interface ContentsSearchRequest extends CommonRequest {
  typeSearch: TypeSearch;
  typeSelect: TypeSearchTargetPage;
  urls: string[];
  urlIds: string[] | null;
  contents: string[];
}

export enum SearchStatus {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
}

export interface ContentsSearchHistory {
  searchId: string;
  typeSearch: TypeSearch;
  typeSelect: TypeSearchTargetPage;
  urls: string[];
  urlIds: string[];
  contents: string[];
  status: SearchStatus.COMPLETED | SearchStatus.RUNNING;
  detectionCount: number;
  numberOfPages: number;
  batchSize: number;
}

export interface FragmentSearchHistory {
  urlId: string;
  title: string;
  shortUrl: string;
  line: number;
  data: string;
  rawHtmlLine: string;
}
